import * as COLORS from '../sharedConstants';

export const styles = {
  root: {
    width: '100%'
  },
  inputLabel: {
    fontSize: '1rem',
    fontFamily: 'Proxima Nova, Nunito Sans, sans-serif',
    marginBottom: '5px'
  },
  formControl: {
    color: 'black',
    width: 'inherit'
  },
  autoComplete: {
    borderColor: '#d9d9d9',
    display: 'flex',
    borderRadius: '5px',
    width: 'inherit'
  },
  formHelperText: {
    marginTop: '2px'
  },
  labelControl: {
    color: COLORS.ERROR_MEDIUM
  }
};
